import React, {useContext, useEffect} from "react";
import {QuotationContext} from "../../../../contexts/QuotationContext";
import {MtplQuotation} from "../../../../model/quotation";
import {Formik} from "formik";
import {getSnippetByName} from "../../../../api/snippetApiClient";
import {WIDGET_DURATION, WidgetTooltip} from "../../../../App";
import {ChatWidget} from "../../../../model/chatWidget";
import {useHotjar} from "../../../../utils/hooks/useHotjar";
import {Form} from "./Form";
import {useValidate} from "./useValidate";
import {PartyType} from "../../../../model/party";
import {Event} from "./formHelpers";
import {ProcessingContext} from "../../../../contexts/ProcessingContext";
import {QuotationCardContext} from "../../../../contexts/QuotationCardContext";
import {fieldsName} from "./consts";

interface Props {
    onFormSubmit: (quotation: MtplQuotation) => void
    backStepHandler: (quotation: MtplQuotation) => void
}

export const MTPLPersonalInfoForm = ({onFormSubmit, backStepHandler}: Props) => {
    const {
        quotation,
        agreeOption1,
        agreeInformOption,
        tarrificationProgram,
        type
    } = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const { trackHotjar } = useHotjar()
    const { validate } = useValidate();
    const { setProcessingOpen } = useContext(ProcessingContext);
    const { validateFields, loadFromServer } = useContext(QuotationCardContext);

    useEffect(() => {
        loadFromServer(Object.values(fieldsName))
    }, [])

    useEffect(() => {
        let timout: NodeJS.Timeout
        getSnippetByName(ChatWidget.TEMPLATE_HINT_FILL_INFO).then(res => {
            timout = setTimeout(() => {
                WidgetTooltip?.open(res.text, WIDGET_DURATION)
            }, 1000)
        })

        let event = Event[tarrificationProgram]
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});
        //Тут виходить дещо колізія, що 2 івента мають бути в однаковий час? Гадаю, при тестуванні вже скажуть, так потрібно чи ні
        trackHotjar("confirm-sum", type)
        trackHotjar("data", type)

        return () => {
            clearTimeout(timout)
            WidgetTooltip?.close()
        }
    }, [])

    const handleSubmit = (quotation: MtplQuotation) => {
        setProcessingOpen(true);

        validateFields(quotation).then(res => {
            if (res) {
                onFormSubmit(quotation);
            } else {
                setProcessingOpen(false);
            }
        });
    }

    return (
        <div className='personal-info-container'>
            <Formik
                initialValues={{
                    agree1: agreeOption1,
                    agreeInform: agreeInformOption,
                    quotation: {
                        ...quotation,
                        mtplContract: {
                            ...quotation.mtplContract,
                            primaryInsured: {
                                ...quotation.mtplContract.primaryInsured,
                                resident: quotation.mtplContract.primaryInsured.resident || false,
                                partyType: PartyType.PERSON
                            }
                        }
                    }
                }}
                validate={validate}
                onSubmit={values => {
                    handleSubmit(values.quotation);
                }}
            >
                {() => <Form backStepHandler={backStepHandler}/>}
            </Formik>
        </div>
    )
};


